import type { Modification } from '@carboncopyco/types';
import { useMemo } from 'react';
import { useRulesManagerFilters } from '../RulesManager';

export interface Filters {
  locked: 'locked' | 'unlocked';
}

export const useFilteredRules = (rules: Modification<'transaction_rule'>[]) => {
  const filterOptions = useMemo(
    () => ({
      initialFilter: 'unlocked' as Filters['locked'],
      searchKeys: [
        {
          name: 'name',
          getFn: (rule) => rule.content.name,
        },
      ],
      dataSet: rules,
      filterFunc: (rule, filter) =>
        (filter === 'locked' && rule.isLocked) ||
        (filter === 'unlocked' && !rule.isLocked),
    }),
    [rules]
  );

  const {
    setSearchValue,
    searchValue,
    filter,
    setFilter,
    filteredList: filteredRules,
    isFiltersActive,
  } = useRulesManagerFilters<
    Filters['locked'],
    Modification<'transaction_rule'>
  >(filterOptions);

  return {
    filteredRules,
    isFiltersActive,
    filter,
    setFilter,
    setSearchValue,
    searchValue,
  } as const;
};
